import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: '#1b3a6b' },
    },
    shape: { borderRadius: 8 },
});
